type MetricGroupExpandParam =
  | 'experiments'
  | 'experimentCount'
  | 'guardedRollouts'
  | 'guardedRolloutCount'
  | 'releasePolicies'
  | 'releasePolicyCount';

export function getMetricGroupExpandParams(): MetricGroupExpandParam[] {
  return [
    'experiments',
    'experimentCount',
    'guardedRollouts',
    'guardedRolloutCount',
    'releasePolicies',
    'releasePolicyCount',
  ];
}
